module.exports = __webpack_public_path__ + "img/GR.a0609b8d.png";